import { Button, Container, Filter, Table } from "components/ui";
import useUniversitiesContext, {
  IUniversitiesFilter,
} from "../services/universitiesContext";
import { Col, Grid, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Universities = () => {
  const navigate = useNavigate();
  const {
    state: { filterFields, columns, data, loading, total },
    actions: { onRowClick },
  } = useUniversitiesContext();
  return (
    <div>
      <Row>
        <Col xs={18} md={6}>
          <Button
            type="primary"
            style={{ backgroundColor: "dodgerblue" }}
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => navigate("/universities/create")}
          >
            Universitet qo'shish
          </Button>
        </Col>
        <Col xs={6} md={18}>
          <Filter<IUniversitiesFilter>
            filterFields={filterFields}
            onFinish={(values) => {
              console.log(values);
            }}
          />
        </Col>
      </Row>
      <Container padding={false} filter>
        <Table
          columns={columns}
          dataSource={data}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => onRowClick(record, rowIndex), // click row
              style: { cursor: "pointer" },
            };
          }}
          total={total}
          loading={loading}
        />
      </Container>
    </div>
  );
};

export default Universities;
